export default class StickySidebar {

    constructor() {
        if(this.sticky = document.querySelector(".js-sticky-sidebar-element")) {
            this.stickyParent = this.sticky.parentElement
            this._makeSticky()
        }
    }

    _makeSticky() {
        window.addEventListener("scroll", () => {
            this.windowScrollTop = window.pageYOffset
            this.stickyParentOffsetTop = this.stickyParent.offsetTop
            this.stickyBottomValue = Math.round(this.sticky.getBoundingClientRect().bottom)
            this.stickyTopValue = Math.round(this.sticky.getBoundingClientRect().top)
            this.main = document.querySelector("main")
            this.mainBottomValue = Math.round(this.main.getBoundingClientRect().bottom)
            this.mainContentHeight = document.querySelector(".main-content").clientHeight
            this.stickyHeight = this.sticky.clientHeight
            this.headerHeight = document.querySelector(".pageheader").clientHeight

            this.stickyParentOffset = this.stickyParent.offsetTop
            this.stickyParentHeight = this.sticky.clientHeight
            this.viewportHeight = window.innerHeight

            // only make it sticky if the content height inside the <main> is greater than the height of the sticky element
            // if the document scrolltop px-value is greater than the sidebartop px-value
            if (this.mainContentHeight > this.stickyHeight) {
                if (this.windowScrollTop + this.headerHeight > this.stickyParentOffsetTop) {

                    // the bottom px-value of the <main> element is greater than the bottom px-value of the sticky element
                    if (this.mainBottomValue > this.stickyBottomValue) {
                        this.sticky.classList.add("sticky-sidebar-active")
                    }

                    else if (this.mainBottomValue <= this.stickyBottomValue && this.stickyTopValue > this.headerHeight) {
                        this.sticky.classList.remove("sticky-sidebar-bottom")
                        this.sticky.classList.add("sticky-sidebar-active")
                    }

                    else {
                        this.sticky.classList.add("sticky-sidebar-bottom")
                        this.sticky.classList.remove("sticky-sidebar-active")
                    }
                }

                // the document scrolltop px-value is smaller than the sidebartop px-value
                else {
                    this.sticky.classList.remove("sticky-sidebar-active")
                }
            }

            // if the sidebar goes beyond the bottom of the viewport, don't make it sticky
            if ((this.stickyParentOffset + this.stickyParentHeight) > this.viewportHeight) {
                this.sticky.classList.remove("sticky-sidebar-active")
            }
        })
    }
}